import { render, staticRenderFns } from "./stockItemDetailPage.vue?vue&type=template&id=1bd54374&"
import script from "./stockItemDetailPage.vue?vue&type=script&lang=ts&"
export * from "./stockItemDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports